// Instructor Routes
import React from 'react'

// Import components for Instructor
import { ClassList, StudentUpdate, TaskManage } from '../Components/ClassManagement'
import { ProfileEdit } from '../Components/Common/ProfileEdit'
import { ChangePassword } from '../Components/Common/ChangePassword'
import { InstructorProfile } from '../Components/Common/InstructorProfile'
import { InstructorCollegeList, InstructorCollegeEdit, StudentCollegeList, StudentCollegeList911 } from '../Components/CollegeManagement'
import { InstructorScheduleList, InstructorScheduleAdd } from '../Components/ScheduleManagement'
import { InstructorResourceList, InstructorResourceEdit } from '../Components/ResourceManagement'
import { InstructorTaskList, InstructorTaskAdd } from '../Components/TaskManagement'
import { InstructorNotesList, InstructorNotesEdit } from '../Components/NotesManagement'
import { AdminPrivateNoteList, AdminPrivateNoteEdit } from '../Components/PrivateNoteManagement'
import {
	InstructorStudentTaskList,
	InstructorStudentTaskEdit,
	GlobalCheckListEdit,
	CollegeProfile,
	ApplicationProfile
} from '../Components/StudentManagement'
import {
	InstructorStudentActivityList,
	InstructorStudentActivityEdit,
	InstructorStudentAwardEdit,
	Student911Activities,
	Student911Awards,
	Student911CongressionalAwards,
} from '../Components/ActivitiesAwards'
import { StudentPersonalQuestions } from '../Components/PersonalQuestions'
import { StudentGradeInMonth, StudentGradeInMonth2, StudentLessonsForGrade, StudentLessonEditForGrade } from '../Components/GradeManagement'
import { StudentLessons, StudentLessonEdit } from '../Components/Lessons'
import { StudentGoalQuestions } from '../Components/GoalQuestions'
import { StudentBookList } from '../Components/BookList'
import { CollegeListForGoals } from '../Components/GoalQuestions'
import { StudentCurriculumTable } from '../Components/CurriculumManagement'
import { StudentDeadlines } from '../Components/Deadlines'
import { StudentFinancialAid } from '../Components/FinancialAid'
import { StudentMainEssay } from '../Components/MainEssay'
import { StudentSupplementalEssay } from '../Components/SupplementalEssay'
import { StudentAdditionalInfo } from '../Components/AdditionalInfo'
import { StudentBragSheet } from '../Components/BragSheet'

export const instructorRoutes = [
	// Class Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/class-management/:layout`, Component: <ClassList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/class-management/student-update/:id/:layout`, Component: <StudentUpdate /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/class-management/add-task/:id/:type/:layout`, Component: <TaskManage /> },

	// College Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/colleges/:layout`, Component: <InstructorCollegeList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/colleges/create/:layout`, Component: <InstructorCollegeEdit /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/colleges/edit/:id/:layout`, Component: <InstructorCollegeEdit /> },

	// Schedule Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/schedules/:layout`, Component: <InstructorScheduleList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/student-schedule/:studentId/:layout`, Component: <InstructorScheduleList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/schedules/create/:studentId/:layout`, Component: <InstructorScheduleAdd /> },

	// Resource Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/resources/:layout`, Component: <InstructorResourceList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/resources/create/:layout`, Component: <InstructorResourceEdit /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/resources/edit/:id/:layout`, Component: <InstructorResourceEdit /> },

	// Task Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/tasks/:layout`, Component: <InstructorTaskList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/tasks/create/:layout`, Component: <InstructorTaskAdd /> },

	// Notes Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/notes/:layout`, Component: <InstructorNotesList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/notes/create/:studentId/:layout`, Component: <InstructorNotesEdit /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/notes/edit/:noteId/:layout`, Component: <InstructorNotesEdit /> },

	// Private Note Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/private-notes/:layout`, Component: <AdminPrivateNoteList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/private-notes/create/:layout`, Component: <AdminPrivateNoteEdit /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/private-notes/edit/:id/:layout`, Component: <AdminPrivateNoteEdit /> },

	// Student Task Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/student-tasks/:studentId/:layout`, Component: <InstructorStudentTaskList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/student-task-edit/:status/:layout`, Component: <InstructorStudentTaskEdit /> },

	// Checklist Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/checklist-edit/:slug/:status/:id/:layout`, Component: <GlobalCheckListEdit /> },

	// Student Profile Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/student-college-profile/:id/:layout`, Component: <CollegeProfile /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/student-application-profile/:id/:layout`, Component: <ApplicationProfile /> },

	// Student Activity Management Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/student-12-activities/:studentId/:layout`, Component: <InstructorStudentActivityList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/student-activity-edit/:studentId/:status/:id/:layout`, Component: <InstructorStudentActivityEdit /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/award-edit/:studentId/:status/:id/:layout`, Component: <InstructorStudentAwardEdit /> },

	// Student Personal Questions
	{ path: `${process.env.PUBLIC_URL}/instructor/student-personal-questions/:studentId/:layout`, Component: <StudentPersonalQuestions /> },
	// desired colleges list
	{ path: `${process.env.PUBLIC_URL}/instructor/student-desired-college-list/:studentId/:layout`, Component: <CollegeListForGoals /> },

	// Student Grades
	{ path: `${process.env.PUBLIC_URL}/instructor/student-grade-list/:studentId/:layout`, Component: <StudentGradeInMonth /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/student-grade-list-2/:studentId/:layout`, Component: <StudentGradeInMonth2 /> },
	{
		path: `${process.env.PUBLIC_URL}/instructor/instructor-studentlessonforgrade/:studentId/:layout`,
		Component: <StudentLessonsForGrade />
	},
	{
		path: `${process.env.PUBLIC_URL}/instructor/instructor-studentlessoneditforgrade/:studentId/:status/:layout`,
		Component: <StudentLessonEditForGrade />
	},
	// Student Lessons
	{ path: `${process.env.PUBLIC_URL}/instructor/student-lessons/:studentId/:layout`, Component: <StudentLessons /> },
	{
		path: `${process.env.PUBLIC_URL}/instructor/instructor-studentlessonedit/:studentId/:status/:layout`,
		Component: <StudentLessonEdit />
	},
	// Student Goal Questions
	{ path: `${process.env.PUBLIC_URL}/instructor/student-goal-questions/:studentId/:layout`, Component: <StudentGoalQuestions /> },
	// Student Book List
	{ path: `${process.env.PUBLIC_URL}/instructor/student-booklist/:studentId/:layout`, Component: <StudentBookList /> },
	// Student Activities
	{ path: `${process.env.PUBLIC_URL}/instructor/student-911-activities/:studentId/:layout`, Component: <Student911Activities /> },
	// Student Awards
	{ path: `${process.env.PUBLIC_URL}/instructor/student-911-awards/:studentId/:layout`, Component: <Student911Awards /> },
	// Student Congressional Awards
	{ path: `${process.env.PUBLIC_URL}/instructor/student-911-congressional-awards/:studentId/:layout`, Component: <Student911CongressionalAwards /> },
	// Student Curriculum Table
	{ path: `${process.env.PUBLIC_URL}/instructor/student-timeline/:studentId/:layout`, Component: <StudentCurriculumTable /> },
	// Student College List
	{ path: `${process.env.PUBLIC_URL}/instructor/student-college-list/:studentId/:layout`, Component: <StudentCollegeList /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/student-911-college-list/:studentId/:layout`, Component: <StudentCollegeList911 /> },
	// Student Deadlines
	{ path: `${process.env.PUBLIC_URL}/instructor/student-deadlines/:studentId/:layout`, Component: <StudentDeadlines /> },
	// Student Financial Aid
	{ path: `${process.env.PUBLIC_URL}/instructor/student-financial-aid/:studentId/:layout`, Component: <StudentFinancialAid /> },
	// Student Main Essay
	{ path: `${process.env.PUBLIC_URL}/instructor/student-main-essay/:studentId/:layout`, Component: <StudentMainEssay /> },
	// Student Supplemental Essay
	{ path: `${process.env.PUBLIC_URL}/instructor/student-supplemental-essay/:studentId/:layout`, Component: <StudentSupplementalEssay /> },
	// Student Additional Info
	{ path: `${process.env.PUBLIC_URL}/instructor/student-additional-info/:studentId/:layout`, Component: <StudentAdditionalInfo /> },
	// Student Brag Sheet
	{ path: `${process.env.PUBLIC_URL}/instructor/student-brag-sheet/:studentId/:layout`, Component: <StudentBragSheet /> },

	// Profile Routes
	{ path: `${process.env.PUBLIC_URL}/instructor/profile/:layout`, Component: <InstructorProfile /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/profile-edit/:layout`, Component: <ProfileEdit /> },
	{ path: `${process.env.PUBLIC_URL}/instructor/change-password/:layout`, Component: <ChangePassword /> }
]
